<template>
  <div>
    <RouterView
      :style="{
        '--inner-height': innerHeight
      }" />
    <Viewer />
  </div>
</template>

<script>
import Viewer from './components/Viewer/index.vue';
export default {
  data () {
    this.innerHeight = `${window.innerHeight}px`
    return {}
  },
  components: {
    Viewer
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue